export const INVOICING_DEALER_SEARCH_THRESHOLD = 10;

export type InvoicingDealerControl = 'select' | 'search';

export function invoicingDealerControl(optionCount: number): InvoicingDealerControl {
    return optionCount > INVOICING_DEALER_SEARCH_THRESHOLD ? 'search' : 'select';
}

export function isSoleOptionAnnouncement(optionCount: number, hasValue: boolean): boolean {
    return optionCount === 1 && !hasValue;
}
